import { render, staticRenderFns } from "./ArticleListIndex.vue?vue&type=template&id=1fe13dc2&scoped=true"
import script from "./ArticleListIndex.vue?vue&type=script&lang=js"
export * from "./ArticleListIndex.vue?vue&type=script&lang=js"
import style0 from "./ArticleListIndex.vue?vue&type=style&index=0&id=1fe13dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe13dc2",
  null
  
)

export default component.exports